import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/apiClient";
import { toast } from "sonner";
import { formatApiError } from "@/contexts/AuthContext";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(searchParams.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setErr("Passwords don't match"); return; }
    setLoading(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. You can now log in.");
      nav("/login");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="reset-page">
      <h1 className="font-display font-black text-5xl tracking-tighter mb-8">New Password</h1>
      <form onSubmit={submit} className="space-y-4">
        <input required className="vt-input" placeholder="Reset token" value={token} onChange={(e) => setToken(e.target.value)} data-testid="reset-token" />
        <input required type="password" minLength={6} className="vt-input" placeholder="New password (min 6)" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
        <input required type="password" minLength={6} className="vt-input" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
        {err && <div className="text-red-600 text-sm" data-testid="reset-error">{err}</div>}
        <button disabled={loading} className="vt-btn-orange w-full" data-testid="reset-submit">{loading ? "..." : "Reset Password"}</button>
      </form>
      <p className="mt-6 text-sm text-neutral-500">
        <Link to="/login" className="link-underline text-black font-bold">Back to Login</Link>
      </p>
    </div>
  );
}
